export enum ReturnMethod {
  OriginalPaymentMethod,
  SiteCredit
}
